<template>
<div class="position-relative overflow-hidden" :dir="isHebrew ? 'rtl' : 'ltr'">
    <NavBar/>
    <div>
      <img
        alt=""
        class="background-image"
        src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fcircles-background.png?alt=media&token=d420088e-66c6-4c95-bd3b-2f218dd36aba">
    </div>
    <ImageBanner :backgroundImage= "'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fride-info-banner.jpg?alt=media&token=b765e21f-2604-4874-a029-3453357e4897'"
                 :paragraph="t('generateOneTimeAccessBannerParagraph')"
                 size="240px"
                 :title="t('generateOneTimeAccessBannerTitle')"/>
  <b-container>
    <b-row class="justify-content-center">
      <b-col col md="6">
        <b-form>
          <b-form-group
              id="label-title"
              :class="isHebrew ? 'text-right' : 'text-left'"
              :label="t('generateOneTimeAccessRecipientDetailsLabel')"
              label-for="title">
            <b-form-input
              v-model="localRecipientDetailsForOneUserAccess"
              id="title"
              :class="['form-control border-primary rounded-2 py-4', isHebrew ? 'text-right' : 'text-left']"
              placeholder=""
              required
              type="text"
            >
            </b-form-input>
          </b-form-group>
        </b-form>
        <PrimaryButton
          class="w-100 mb-5"
          @click="this.localGetAccessKeyForOneUser"
        >
          {{ t('generateOneTimeAccessCreateLinkButton') }}
        </PrimaryButton>
        <b-form>
          <b-form-group
              id="label-title"
              :class="isHebrew ? 'text-right' : 'text-left'"
              :label="t('generateOneTimeAccessSingleUserLinkLabel')"
              label-for="title">
            <b-form-input
              v-model="localOneTimeRideAccesskey"
              id="title"
              :class="['form-control border-primary rounded-2 py-4', isHebrew ? 'text-right' : 'text-left']"
              placeholder=""
              required
              type="text"
              readonly
            >
            </b-form-input>
            <b-button @click="copyLink" variant="primary" class="mt-2">
              {{ t('generateOneTimeAccessCopyLinkButton') }}
            </b-button>
          </b-form-group>
        </b-form>
        <SecondaryButton
          :callBack="returnToRide"
          class="w-100 mb-5"
        >
          {{ t('generateOneTimeAccessBackToTripButton') }}
        </SecondaryButton>
      </b-col>
    </b-row>
  </b-container>
  <AppFooter/>
</div>
</template>

<script>
import ImageBanner from "@/components/ImageBanner/ImageBanner.vue";
import PrimaryButton from "@/components/Buttons/PrimaryButton.vue";
import NavBar from "@/components/NavBar.vue";
import AppFooter from "@/components/Template/AppFooter.vue";
import SecondaryButton from "@/components/Buttons/SecondaryButton.vue";
import { mapActions, mapGetters } from 'vuex';
import { translationMixin } from "@/mixins/translationMixin";

export default {
  name: 'GeneratOneTimeAccessKey',
  mixins: [translationMixin],
  components: {
    AppFooter,
    PrimaryButton,
    ImageBanner,
    NavBar,
    SecondaryButton,
    },
  computed: {...mapGetters([  'oneTimeRideAccesskey',
                              'userId',
                              ]),
      
      localRecipientDetailsForOneUserAccess:{
        get () {
          return "";
        },
        set (value) {
          const convertedValue = `by user: ${this.userId} - ${value}`;
          const limitedValue = convertedValue.substring(0, 200);
          this.$store.commit('setRecipientDetailsForOneUserAccess', limitedValue)
        },
      },
      localOneTimeRideAccesskey:{
        get () {
          return this.oneTimeRideAccesskey
        },
      },
    },
    methods:
    {
    ...mapActions([ 'getOneUserAccessKey',
                    ] ),
    localGetAccessKeyForOneUser() {
      const rideIdFromUrl = this.$route.params.ride_id;
      this.getOneUserAccessKey( rideIdFromUrl )
    },
    
    returnToRide() {
      const rideIdFromUrl = this.$route.params.ride_id;
      if (rideIdFromUrl) {
        this.$router.push('/single_ride_with_map/' + rideIdFromUrl);
      }
    },

    copyLink() {
      const link = this.oneTimeRideAccesskey;
      navigator.clipboard
        .writeText(link)
        .then(() => {
          this.$bvToast.toast(this.t('generateOneTimeAccessCopySuccessMessage'), {
            title: this.t('generateOneTimeAccessCopySuccessTitle'),
            variant: 'success',
            solid: true,
          });
        })
        .catch((err) => {
          console.error('Failed to copy link: ', err);
          this.$bvToast.toast(this.t('generateOneTimeAccessCopyErrorMessage'), {
            title: this.t('generateOneTimeAccessCopyErrorTitle'),
            variant: 'danger',
            solid: true,
          });
        });
    },
  },
};
</script>


<style scoped>
.custom-height {
  height: 50px; /* Adjust to desired height */
  line-height: 1.5; /* Ensures proper text alignment */
}

#checkbox-1 {
  display: flex;
  align-items: center;
}
#checkbox-2 {
  display: flex;
  align-items: center;
}

.form-control{
  background-color: white !important;
}
.dropdown-menu {
  margin-top: 6px;
  width: 100% !important;
}


</style>